import { render, staticRenderFns } from "./SithMesMstMaterialDocumentEdit.vue?vue&type=template&id=4ae423c5&"
import script from "./SithMesMstMaterialDocumentEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesMstMaterialDocumentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports